/**
 * 错误消息工具函数
 *
 * 提供用户友好的错误消息映射
 */

// 错误模式与消息的映射关系
const ERROR_PATTERNS: Array<[RegExp | string, string]> = [
  [/network|fetch|timeout/i, '网络连接失败,请检查网络后重试'],
  [/timeout/i, '请求超时,请重试'],
  [/unauthorized|401/, '登录已过期,请重新登录'],
  [/forbidden|403/, '权限不足,无法执行此操作'],
  [/not found|404/, '请求的资源不存在'],
  [/conflict|409/, '数据冲突,请刷新后重试'],
  [/internal|500/, '服务器内部错误,请稍后重试'],
];

/**
 * 获取用户友好的错误消息
 *
 * @param error - 错误对象
 * @returns 用户友好的错误消息
 */
export function getUserFriendlyErrorMessage(error: unknown): string {
  // 处理 TypeError（通常是网络错误）
  if (error instanceof TypeError && /fetch|network/i.test(error.message)) {
    return '网络连接失败,请检查网络后重试';
  }

  // 处理标准 Error 对象
  if (error instanceof Error) {
    const message = error.message.toLowerCase();

    for (const [pattern, msg] of ERROR_PATTERNS) {
      if (pattern instanceof RegExp) {
        if (pattern.test(message)) {
          return msg;
        }
      } else if (message.includes(pattern.toLowerCase())) {
        return msg;
      }
    }
  }

  return '操作失败,请重试';
}
